import React, {Component} from "react";
import '../../components_style/doctorComponents/RegisterForm.css'
import Constants from "../../utils/constants";
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import {BsX} from 'react-icons/bs';
import AgeSlider from "./AgeSlider";
import { AiOutlineCheckCircle } from 'react-icons/ai';
import {compose} from "redux";
import {withTranslation} from "react-i18next";




class FilterComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entry: {},
            matrix: [2, 2, 1, 1],
            fields: [
                {
                    type: 'text',
                    max: 20,
                    name: 'First_name',
                    display: 'First name',
                    placeholder: 'Enter first name',
                    required: true,
                    width: 0.5,
                    style: 'inline'
                },
                {
                    type: 'text',
                    max: 20,
                    name: 'Last_name',
                    display: 'Last name',
                    placeholder: 'Enter last name',
                    required: true,
                    width: 0.5,
                    style: 'inline'
                },
                {
                    type: 'phone',
                    max: 50,
                    name: 'Phone_num11',
                    display: 'Phone number',
                    placeholder: 'Enter Phone number',
                    required: true,
                    width: 0.5,
                    style: 'inline'
                },
                {
                    type: 'dropdown',
                    name: 'Role',
                    display: 'Role',
                    placeholder: 'Enter Role',
                    required: false,
                    width: 0.5,
                    style: 'inline',
                    options: Constants.adminRoles
                },
                {
                    type: 'text',
                    max: 100,
                    name: 'Email1',
                    display: 'Email',
                    placeholder: 'Enter email',
                    required: true,
                    width: 1,
                    style: 'inline'
                },
                {
                    type: 'checkbox',
                    name: 'TwoFA',
                    display: 'is 2FA required',
                    width: 1,
                    style: 'block',
                    required: false
                },
            ],
            errors: {},
            errorsOnSave: {},
            StatusExpand: MdExpandLess,
            DiagnosisExpand: MdExpandLess,
            TreatmentExpand: MdExpandLess,
            SexExpand: MdExpandLess,
            AgeExpand: MdExpandLess,

            // domain: [200, 500],
            // values: defaultValues.slice(),
            // update: defaultValues.slice(),
            // reversed: false,

            filters:this.props.filters,
        }
    }

    componentWillMount(){
        let {filters}=this.state
/*/!*
        if (this.props.filters[0])
            this.setState({filters: this.props.filters[0]})
*!/


        if (this.props.filters){
            for(let i=0;i<this.props.filters.length;i++){
                Object.entries(this.props.filters[i]).forEach(([name,value]) => {
                    filters[name]=value
                })
            }
        }

        this.setState()*/
    }


    async closeSideBar(){
        document.body.style.overflow = "auto"
        this.props.closeSideBar(false)
        this.setState({entry:null})
    }
 /*   changeCheckbox = (name) => {
        let state = this.state
        let val = !state[name]
        state[name] = val
        this.setState( state)
    }*/

    applyFilter(name,cat,field){
    this.props.applyFilter(name,cat,field)
    }


    handleSliderChange(cat,valArr){
        let {filters} = this.state
        filters[cat] = valArr
        this.setState({filters});
        this.props.filterPatientsTable('filters', filters);
    }

    expandFilter(id){
        let display = document.getElementById(id).style.display
        if (display === "block") display = "none"
        else display = "block"

        switch (id){
            case "status-panel":{
                if (display === "block"){
                    this.setState({StatusExpand: MdExpandLess})
                } else {
                    this.setState({StatusExpand: MdExpandMore})
                }
                break;
            }
            case "diagnosis-panel":{
                if (display === "block"){
                    this.setState({DiagnosisExpand: MdExpandLess})
                } else {
                    this.setState({DiagnosisExpand: MdExpandMore})
                }
                break;
            }
            case "treatment-panel":{
                if (display === "block"){
                    this.setState({TreatmentExpand: MdExpandLess})
                } else {
                    this.setState({TreatmentExpand: MdExpandMore})
                }
                break;
            }
            case "Sex-panel":{
                if (display === "block"){
                    this.setState({SexExpand: MdExpandLess})
                } else {
                    this.setState({SexExpand: MdExpandMore})
                }
                break;
            }
            case "Age-panel":{
                if (display === "block"){
                    this.setState({AgeExpand: MdExpandLess})
                } else {
                    this.setState({AgeExpand: MdExpandMore})
                }
                break;
            }
        }
        document.getElementById(id).style.display = display;
    }

    render() {
        let display = this.props.isSideBarOpen ? 'block' : 'none'
        let width = this.props.isSideBarOpen ? "600px" : "0px"
        let container_width = this.props.isSideBarOpen ? "100%" : "0px"
        let {StatusExpand,DiagnosisExpand,TreatmentExpand,SexExpand,AgeExpand} = this.state

        let {filters} = this.state
        let {t} = this.props

        return (
            <div className={"sidenav-complete2"} style={{width:container_width, height:"100%"}} >
                <div className={"sidenav-complete2"} style={{width:container_width, height:"100%"}} onClick={this.closeSideBar.bind(this)}/>
                <div className={"sidenav"} style={{width:width, height:"100%", float:'right'}}>
                    <BsX onClick={this.closeSideBar.bind(this)} size={35} style={{
                        float: 'left',
                        top: '10px',
                        left: '10px',
                        position: 'absolute',
                    }}/>
                    <div className={'filterFont'}> {t('doctor.filter.filter')}</div>
                    <div className={'filterBorders'}>
                        <div className={'filterTypes'}>
                            <div className={'filterTypes-header'}>
                                <div className={'filterTypes-header-title pointer'} onClick={() => this.expandFilter('status-panel')}>{t('doctor.filter.status')}</div>
                                <StatusExpand className={'expandingIcon pointer'} size={35} onClick={() => this.expandFilter('status-panel')}/>
                            </div>
                            <div id={'status-panel'} style={{display: "block"}}>
                                <div className={'filterTypes-header'}>
                                    <div className={'filterOptions filterTypes-header-title'}
                                         style={{fontWeight: filters.Status.includes('Active') ? 'bold' : 'normal'}}
                                         onClick={() => this.applyFilter('activeClicked', 'Status','Active')}> {t('doctor.filter.active')} </div>
                                    <AiOutlineCheckCircle style={{display: filters.Status.includes('Active')?'inline-block': 'none'}} className={'expandingIcon'} size={18} />
                                </div>
                                <div className={'filterTypes-header'}>
                                    <div className={'filterOptions filterTypes-header-title'}
                                         style={{fontWeight: filters.Status.includes('Inactive') ? 'bold' : 'normal'}}
                                         onClick={() => this.applyFilter('inactiveClicked','Status','Inactive')}> {t('doctor.filter.inactive')} </div>
                                    <AiOutlineCheckCircle style={{display: filters.Status.includes('Inactive') ?'inline-block': 'none'}} className={'expandingIcon'} size={18} />
                                </div>
                                <div className={'filterTypes-header'}>
                                    <div className={'filterOptions filterTypes-header-title'}
                                         style={{fontWeight: filters.Status.includes('Awaiting License') ? 'bold' : 'normal'}}
                                         onClick={() => this.applyFilter('AwaitingLicenseClicked','Status','Awaiting License')}> {t('doctor.filter.awaiting_license')} </div>
                                    <AiOutlineCheckCircle style={{display: filters.Status.includes('Awaiting License')?'inline-block': 'none'}} className={'expandingIcon'} size={18} />
                                </div>
                                <div className={'filterTypes-header'}>
                                    <div className={'filterOptions filterTypes-header-title'}
                                         style={{fontWeight: filters.Status.includes('Awaiting Documents') ? 'bold' : 'normal'}}
                                         onClick={() => this.applyFilter('awaitingDocumentsClicked','Status','Awaiting Documents')}>  {t('doctor.filter.awaiting_documents')} </div>
                                    <AiOutlineCheckCircle style={{display: filters.Status.includes('Awaiting Documents')?'inline-block': 'none'}} className={'expandingIcon'} size={18} />
                                </div>

                            </div>
                        </div>
                        <div className={'filterTypes'}>
                            <div className={'filterTypes-header'}>
                                <div className={'filterTypes-header-title pointer'} onClick={() => this.expandFilter('diagnosis-panel')}> {t('doctor.filter.diagnosis')}</div>
                                <DiagnosisExpand className={'expandingIcon pointer'} size={35} onClick={() => this.expandFilter('diagnosis-panel')}/>
                            </div>
                            <div id={'diagnosis-panel'} style={{display: "block"}}>
                                <div className={'filterTypes-header'}>
                                    <div className={'filterOptions filterTypes-header-title'}
                                         style={{fontWeight: filters.Diagnosis.includes('P.T.S.D') ? 'bold' : 'normal'}}
                                         onClick={() => this.applyFilter('ptsdClicked','Diagnosis','P.T.S.D')}>  {t('doctor.filter.ptsd')} </div>
                                    <AiOutlineCheckCircle style={{display: filters.Diagnosis.includes('P.T.S.D')?'inline-block': 'none'}} className={'expandingIcon'} size={18} />
                                </div>
                                <div className={'filterTypes-header'}>
                                    <div className={'filterOptions filterTypes-header-title'}
                                         style={{fontWeight: filters.Diagnosis.includes('CVA') ? 'bold' : 'normal'}}
                                         onClick={() => this.applyFilter('cvaClicked', 'Diagnosis','CVA')}>   {t('doctor.filter.CVA')} </div>
                                    <AiOutlineCheckCircle style={{display: filters.Diagnosis.includes('CVA')?'inline-block': 'none'}} className={'expandingIcon'} size={18} />
                                </div>
                            </div>
                        </div>
                        <div className={'filterTypes'}>
                            <div className={'filterTypes-header'}>
                                <div className={'filterTypes-header-title pointer'} onClick={() => this.expandFilter('treatment-panel')}>Treatment</div>
                                <TreatmentExpand className={'expandingIcon pointer'} size={35} onClick={() => this.expandFilter('treatment-panel')}/>
                            </div>
                            <div id={'treatment-panel'} style={{display: "block"}}>
                                <div className={'filterTypes-header'}>
                                    <div className={'filterOptions filterTypes-header-title'}
                                         style={{fontWeight: filters.Treatment.includes('Drops') ? 'bold' : 'normal'}}
                                         onClick={() => this.applyFilter('oilClicked','Treatment','Drops')}>  {t('doctor.filter.oil')} </div>
                                    <AiOutlineCheckCircle style={{display: filters.Treatment.includes('Drops')?'inline-block': 'none'}} className={'expandingIcon'} size={18} />
                                </div>
                                <div className={'filterTypes-header'}>
                                    <div className={'filterOptions filterTypes-header-title'}
                                         style={{fontWeight: filters.Treatment.includes('Hin') ? 'bold' : 'normal'}}
                                         onClick={() => this.applyFilter('flowerClicked', 'Treatment','Hin')}>  {t('doctor.filter.flower')} </div>
                                    <AiOutlineCheckCircle style={{display: filters.Treatment.includes('Hin')?'inline-block': 'none'}} className={'expandingIcon'} size={18} />
                                </div>
                            </div>
                        </div>
                        <div className={'filterTypes'}>
                            <div className={'filterTypes-header'}>
                                <div className={'filterTypes-header-title pointer'} onClick={() => this.expandFilter('Sex-panel')}>{t('doctor.filter.sex')}</div>
                                <SexExpand className={'expandingIcon pointer'} size={35} onClick={() => this.expandFilter('Sex-panel')}/>
                            </div>
                            <div id={'Sex-panel'} style={{display: "block"}}>
                                <div className={'filterTypes-header'}>
                                    <div className={'filterOptions filterTypes-header-title'}
                                         style={{fontWeight: filters.Gender.includes('M') ? 'bold' : 'normal'}}
                                         onClick={() => this.applyFilter('maleLicenseClicked','Gender','M')}>  {t('doctor.filter.male')} </div>
                                    <AiOutlineCheckCircle style={{display: filters.Gender.includes('M') ?'inline-block': 'none'}} className={'expandingIcon'} size={18} />
                                </div>
                                <div className={'filterTypes-header'}>
                                    <div className={'filterOptions filterTypes-header-title'}
                                         style={{fontWeight: filters.Gender.includes('F')  ? 'bold' : 'normal'}}
                                         onClick={() => this.applyFilter('femaleClicked','Gender','F')}>  {t('doctor.filter.female')} </div>
                                    <AiOutlineCheckCircle style={{display: filters.Gender.includes('F')?'inline-block': 'none'}} className={'expandingIcon'} size={18} />
                                </div>
                            </div>
                        </div>
                        <div className={'filterTypes'}>
                            <div className={'filterTypes-header'}>
                                <div className={'filterTypes-header-title pointer'} onClick={() => this.expandFilter('age-panel')}> {t('doctor.filter.age')}</div>
                                <AgeExpand className={'expandingIcon pointer'} size={35} onClick={() => this.expandFilter('age-panel')}/>
                            </div>
                            <div id={'age-panel'} className={'age-panel'} style={{display: "block"}}>
                                <AgeSlider sliderVal={(filters['Age']).length === 2 ? filters['Age'] : [0,100]}

                                           handleSliderChange={() => this.handleSliderChange()}/>
                            </div>
                        </div>
                        <div className={'filterTypes-button'}>
                            <label className={'save-button-filter'} onClick={this.closeSideBar.bind(this)}>save</label>
                        </div>
                    </div>
{/*display block to display none*/}

                </div>

                {/*<div className={'register-form-nav-container block'} >*/}
                {/*    <div className={'register-form-nav'}  style={{width:width,display:'flex',justifyContent:"space-around"}}>*/}
                {/*        <label type={"button"} onClick={this.closeSideBar.bind(this)} style={{display:display}} className={"v-centered close-bar"}>Close</label>*/}
                {/*    </div>*/}
                {/*</div>*/}

            </div>
        );
    }
}
// AdminEditForm.propTypes = {
//     isSideBarOpen:Prototypes.bool.isRequired,
//     closeSideBar:Prototypes.func.isRequired,
//     editAdmin:Prototypes.func.isRequired,
//     title: Prototypes.string.isRequired,
//     entry: Prototypes.object
// }

const Filter = compose(
    withTranslation(),

)(FilterComposed);

export default Filter;
